// src/components/common/ErrorMessage.js

const ErrorMessage = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div className="alert alert-danger alert-dismissible fade show" role="alert">
      <strong>Ошибка:</strong> {message}
      {onClose && (
        <button
          type="button"
          className="btn-close"
          onClick={onClose}
          aria-label="Закрыть"
        ></button>
      )}
    </div>
  );
};

export default ErrorMessage;